<template>
  <div>
    <h3 class="mt-4 ml-5">Meus Serviços</h3>
    <hr/>
    <b-pagination v-model="filter.page" :total-rows="page.totalElements" :per-page="page.size" id="pagination-os" class="ml-5"></b-pagination>
    <div v-if="page" class="ml-5">Mostrando {{page.numberOfElements}} de um total de {{page.totalElements}} registros</div>
    <div class="mobile">
      <div v-for="guideBooking in guideOSBookings" class="card">
        <b-card no-body>
          <span class="header">{{ guideBooking.serviceOrder.file.fileNumber }}</span>
          <b-tabs card justified>
            <b-tab title="Serviço" active>
              <b-card-text>
                <p><b>Data:</b> {{ guideBooking.booking.date }}  </p>
                <p><b>Name:</b> {{ guideBooking.booking.productName }}  </p>
                <p><b>Pax N:</b> {{ guideBooking.booking.paxQty }}  </p>
                <p><b>Pax:</b> {{ guideBooking.serviceOrder.file.pax }}  </p>
                <p><b>Horário:</b> {{ guideBooking.booking.pickup }}  </p>
                <p><b>Pick Up:</b> {{ guideBooking.booking.pickupPlace }}  </p>
              </b-card-text>
            </b-tab>
            <b-tab title="Detalhes">
              <b-card-text>
                <p><b>Fornecedor:</b> {{ guideBooking.transportProvider ? guideBooking.transportProvider.name : '' }}</p>
                <p><b>Voo:</b> {{ guideBooking.flightNumberInformation }}</p>
                <p><b>Hora:</b> {{ guideBooking.flightTimeInformation }}</p>
                <p><b>Origem:</b> {{ guideBooking.flightOriginInformation }}</p>
                <p><b>Destino:</b> {{ guideBooking.flightDestinationInformation }}</p>
                <p><b>Idioma:</b> {{ guideBooking.serviceOrder.file.language.name }}</p>
                <p><b>Cliente:</b> {{ guideBooking.serviceOrder.file.client.name }}</p>
                <p><b>Operador:</b> {{ guideBooking.serviceOrder.file.operator.name }}</p>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
    <b-pagination v-model="filter.page" :total-rows="page.totalElements" :per-page="page.size" class="ml-5"></b-pagination>
  </div>
</template>

<script>
import moment from 'moment';
import ServiceOrderBookingService from '../../service/ServiceOrderBookingService';

export default {
  data() {
    return {
      bookingService: new ServiceOrderBookingService(),
      guideOSBookings: [],
      page: {},
      filter: this.defaultFilter(),
    }
  },
  created() {
    this.listBookings();
  },
  methods: {
    defaultFilter(){
      return {
        page: 1,
        size: 10,
        sortBy: null,
        sortDirection: null,
        startDate: moment().format('DD/MM/YYYY'),
        guideId: this.$store.state.user.id,
      };
    },
    listBookings() {
      this.bookingService.filter(this.filter)
      .then(res => {
        this.page = res.data;
        this.guideOSBookings = res.data.content;
        this.formatBookingDates();
		  })
      .catch(error =>{
        this.$store.dispatch("showAlert",{
          message: "Erro ao carregar os Bookings! " + (error.response ? error.response.data.message : ""),
          style: "danger"
        })
      });
    },
    formatBookingDates() {
      this.guideOSBookings.map(b => b.booking.date = moment(b.booking.date, 'DD/MM/YYYY').format('ddd - DD/MM/YYYY'));
    }
  },
  watch: {
    'filter.page': {
      handler() {
        this.listBookings();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin-left: 8%;
}

.mobile {
  display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	grid-gap: 30px;
	padding: 30px;
}

.card {
  max-width: 500px;
  height: -webkit-fill-available;
}

.header {
  font-weight: bold;
  padding-left: 1.25rem;
  padding-top: 5px;
  padding-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/os/ServiceOrderMap.vue